<div class="conversation-header">
  <button type="button"
          class="btn-back-icon"
          mat-icon-button
          [attr.aria-label]="'common.actions.back' | translate"
          (click)="back.emit()">
    <mat-icon>arrow_back</mat-icon>
  </button>

  <h2 class="conversation-title">{{ subject() || ('message.context.noSubject' | translate) }}</h2>

  @if (messageId() != null) {
  <span class="conversation-id">#{{ messageId() }}</span>
  }

  @if (chips().length > 0) {
  <span class="conversation-separator"></span>

  <div class="conversation-chips">
    @for (chip of chips(); track $index) {
    <app-context-chip [label]="chip.label"
                      [empty]="chip.empty ?? false"
                      [filled]="chip.filled ?? false"
                      [icon]="chip.icon"
                      [avatarText]="chip.avatarText"
                      [avatarColor]="chip.avatarColor"
                      [dotColor]="chip.dotColor"></app-context-chip>
    }
  </div>
  }
</div>
